import { wrapRootElement as doWrapRootElement } from "./src/components/wrapRootElement"

export const wrapRootElement = doWrapRootElement
